/* eslint no-param-reassign:
  ["error", {
    "props": true,
    "ignorePropertyModificationsFor": ["state"]
  }
] */
/*
  - - - - - - - - - - - - - - - - - - - - - - -
  Support Pageable actions for the store.
  Wraps HTTP module and supports setting the result and firing notifications
  - - - - - - - - - - - - - - - - - - - - - - -
*/
import HTTP from '@/utils/http';

export default function pageable() {
  return {
    state: {
      results: [],
      totalCount: 0,
      totalPages: 0,
      currentPage: 0,
      pagingLimit: 50,
    },
    mutations: {
      SET_PAGE_RESULTS(state, { results, count, index }) {
        state.totalCount = count;
        state.totalPages = Math.ceil((count / state.pagingLimit));

        state.results = results;
        state.currentPage = index;
      },
      SET_TOTAL_COUNT(state, count) {
        state.totalCount = count;
        state.totalPages = Math.ceil((count / state.pagingLimit));
      },
      SET_PAGE_LIMIT(state, { limit }) {
        state.pagingLimit = limit;
      },
      CLEAR_RESULTS(state) {
        state.results = new Array(state.pagingLimit);
      },
    },
    getters: {
      allResults: state => state.results, // TODO Redundant. Should be removed
      pagedResults: state => state.results,
      totalPages: state => state.totalPages,
      currentPage: state => state.currentPage,
    },
    actions: {
      paginatePartialApplication({
        params, // Parameters to send to the server
        transform, // Custom results transform function. Runs before setters
        ...otherParams // Custom params for HTTP module
      }) {
        return ({ commit, state }, { page, pageLimit }) => {
          let limit;
          if (pageLimit) {
            limit = parseInt(pageLimit, 10);
            commit('SET_PAGE_LIMIT', { limit });
          } else {
            limit = parseInt(state.pagingLimit, 10);
          }

          commit('CLEAR_RESULTS');

          const offset = parseInt((page - 1) * limit, 10);

          return HTTP({
            ...otherParams,
            params: {
              ...params,
              limit,
              offset,
            },
          }).then(response => (transform ? transform(response) : response)).then((response) => {
            commit('SET_PAGE_RESULTS', {
              results: response.data.data,
              count: response.data.count,
              index: (page - 1),
            });

            return response.data.data;
          });
        };
      },
    },
  };
}
